import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import ImportacaoService from '@/services/ImportacaoService'
import { getErrorMessage } from '@/helpers/error-helpers';
import DialogoDeConfirmacao from '@/components/dialogos/DialogoDeConfirmacao.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportarEventos',
  setup(__props) {

const dialogoDeConfirmacao = ref<InstanceType<typeof DialogoDeConfirmacao> | null>(null)
const selectedFile = ref<File | null>(null)
const campoDeUpload = ref<HTMLInputElement | null>(null)

const queryClient = useQueryClient()

const { mutate, isPending, error, data, reset } = useMutation({
	mutationFn: async (arquivo: File) => {
		const formData = new FormData()
		formData.append('file', arquivo)
		return ImportacaoService.importar('eventos', formData)
	},
	onSuccess() {
		selectedFile.value = null
		queryClient.invalidateQueries({ queryKey: ['eventos'], exact: false })
	},
})

function iniciarUpload() {
	if (!campoDeUpload.value) return
	campoDeUpload.value.click()
}

const handleFileChange = async (event: Event) => {
	const target = event.target as HTMLInputElement
	const file = target.files?.[0]
	if (!file) return

	target.value = ''
	const confirmado = await dialogoDeConfirmacao.value?.abrir({
		titulo: 'Confirmação',
		mensagem: `Tem certeza que deseja importar "${file.name}"?`,
	})
	reset()
	if (confirmado) mutate(file)
}

const errorMessages = computed(() => error ? getErrorMessage(error.value).split('\n') : [])

return { __sfc: true,dialogoDeConfirmacao, selectedFile, campoDeUpload, queryClient, mutate, isPending, error, data, reset, iniciarUpload, handleFileChange, errorMessages, DialogoDeConfirmacao }
}

})